package com.ijoin.platform

actual class MapPicker {
    actual fun pickLocation(callback: (LocationResult?) -> Unit) {
        console.log("MapPicker.pickLocation called!")

        // Check if Google Maps is loaded
        val mapsLoaded = try {
            js("typeof google !== 'undefined' && typeof google.maps !== 'undefined'") as Boolean
        } catch (e: Exception) {
            console.log("Error checking Google Maps: $e")
            false
        }

        console.log("Google Maps loaded: $mapsLoaded")

        if (!mapsLoaded) {
            console.log("Google Maps API not loaded yet - please check that Google Maps script is in index.html")
            callback(null)
            return
        }

        console.log("Opening map picker modal...")

        // Store callback globally
        js("window.__mapPickerCallback = arguments[0]").asDynamic()

        // Create and show map picker modal
        js("""
            (function() {
                var callback = window.__mapPickerCallback;

                // Clean up any previous modal
                var existingModal = document.getElementById('map-picker-modal');
                if (existingModal) {
                    existingModal.remove();
                }

                // Create modal overlay
                var modal = document.createElement('div');
                modal.id = 'map-picker-modal';
                modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);z-index:10000;display:flex;align-items:center;justify-content:center;animation:fadeIn 0.2s';

                var mapContainer = document.createElement('div');
                mapContainer.style.cssText = 'width:90%;max-width:900px;height:85%;background:white;border-radius:12px;display:flex;flex-direction:column;box-shadow:0 10px 40px rgba(0,0,0,0.3)';

                // Header
                var header = document.createElement('div');
                header.style.cssText = 'padding:20px;border-bottom:1px solid #e0e0e0;display:flex;justify-content:space-between;align-items:center;background:#f5f5f5;border-radius:12px 12px 0 0';
                var title = document.createElement('h2');
                title.style.cssText = 'margin:0;font-size:20px;color:#333;font-weight:600';
                title.textContent = 'Select Location on Map';
                var closeBtn = document.createElement('button');
                closeBtn.id = 'closeMapBtn';
                closeBtn.style.cssText = 'border:none;background:none;font-size:28px;cursor:pointer;color:#666;width:32px;height:32px;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:background 0.2s';
                closeBtn.innerHTML = '&times;';
                closeBtn.onmouseover = function() { this.style.background = '#e0e0e0'; };
                closeBtn.onmouseout = function() { this.style.background = 'none'; };
                header.appendChild(title);
                header.appendChild(closeBtn);

                // Search box
                var searchContainer = document.createElement('div');
                searchContainer.style.cssText = 'padding:12px 20px;border-bottom:1px solid #e0e0e0;background:white';
                var searchInput = document.createElement('input');
                searchInput.id = 'map-search-input';
                searchInput.type = 'text';
                searchInput.placeholder = 'Search for a place...';
                searchInput.style.cssText = 'width:100%;padding:10px 12px;border:1px solid #ddd;border-radius:6px;font-size:14px;box-sizing:border-box';
                searchContainer.appendChild(searchInput);

                // Map div
                var mapDiv = document.createElement('div');
                mapDiv.id = 'map-picker-' + Date.now();
                mapDiv.style.cssText = 'flex:1;position:relative';

                // Info text
                var infoText = document.createElement('div');
                infoText.style.cssText = 'position:absolute;top:10px;left:50%;transform:translateX(-50%);background:white;padding:8px 16px;border-radius:20px;box-shadow:0 2px 8px rgba(0,0,0,0.2);z-index:1;font-size:13px;color:#666;pointer-events:none';
                infoText.textContent = 'Click on map to select location';
                mapDiv.appendChild(infoText);

                // Footer
                var footer = document.createElement('div');
                footer.style.cssText = 'padding:16px 20px;border-top:1px solid #e0e0e0;display:flex;justify-content:space-between;align-items:center;background:#f9f9f9;border-radius:0 0 12px 12px';
                var coords = document.createElement('div');
                coords.id = 'coords';
                coords.style.cssText = 'color:#666;font-size:13px;font-family:monospace';
                coords.textContent = 'No location selected';
                var buttonContainer = document.createElement('div');
                buttonContainer.style.cssText = 'display:flex;gap:8px';
                var cancelBtn = document.createElement('button');
                cancelBtn.id = 'cancelMapBtn';
                cancelBtn.style.cssText = 'padding:10px 20px;background:white;color:#666;border:1px solid #ddd;border-radius:6px;cursor:pointer;font-size:14px;font-weight:500;transition:background 0.2s';
                cancelBtn.textContent = 'Cancel';
                cancelBtn.onmouseover = function() { this.style.background = '#f5f5f5'; };
                cancelBtn.onmouseout = function() { this.style.background = 'white'; };
                var confirmBtn = document.createElement('button');
                confirmBtn.id = 'confirmMapBtn';
                confirmBtn.style.cssText = 'padding:10px 24px;background:#1976d2;color:white;border:none;border-radius:6px;cursor:pointer;font-size:14px;font-weight:500;box-shadow:0 2px 4px rgba(25,118,210,0.3);transition:background 0.2s';
                confirmBtn.textContent = 'Confirm Location';
                confirmBtn.onmouseover = function() { this.style.background = '#1565c0'; };
                confirmBtn.onmouseout = function() { this.style.background = '#1976d2'; };
                buttonContainer.appendChild(cancelBtn);
                buttonContainer.appendChild(confirmBtn);
                footer.appendChild(coords);
                footer.appendChild(buttonContainer);

                mapContainer.appendChild(header);
                mapContainer.appendChild(searchContainer);
                mapContainer.appendChild(mapDiv);
                mapContainer.appendChild(footer);
                modal.appendChild(mapContainer);
                document.body.appendChild(modal);

                // Add CSS animation
                var style = document.createElement('style');
                style.textContent = '@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }';
                document.head.appendChild(style);

                // Initialize map
                var defaultPos = { lat: 55.7558, lng: 37.6173 };
                var selectedMarker = null;
                var selectedPos = null;

                // Try to get user location
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function(position) {
                            defaultPos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            };
                            map.setCenter(defaultPos);
                            selectedPos = defaultPos;
                            selectedMarker = new google.maps.Marker({
                                position: defaultPos,
                                map: map,
                                draggable: true,
                                animation: google.maps.Animation.DROP
                            });
                            updateCoordinates(defaultPos);
                            selectedMarker.addListener('dragend', function(e) {
                                selectedPos = { lat: e.latLng.lat(), lng: e.latLng.lng() };
                                updateCoordinates(selectedPos);
                            });
                        }
                    );
                }

                var map = new google.maps.Map(document.getElementById(mapDiv.id), {
                    center: defaultPos,
                    zoom: 13,
                    mapTypeControl: true,
                    streetViewControl: false,
                    fullscreenControl: true,
                    zoomControl: true
                });

                // Search functionality
                var searchBox = new google.maps.places.SearchBox(searchInput);
                searchBox.addListener('places_changed', function() {
                    var places = searchBox.getPlaces();
                    if (places.length === 0) return;
                    var place = places[0];
                    if (!place.geometry || !place.geometry.location) return;
                    if (selectedMarker) selectedMarker.setMap(null);
                    selectedPos = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
                    selectedMarker = new google.maps.Marker({
                        position: selectedPos,
                        map: map,
                        draggable: true,
                        animation: google.maps.Animation.DROP
                    });
                    map.setCenter(selectedPos);
                    map.setZoom(15);
                    updateCoordinates(selectedPos);
                    selectedMarker.addListener('dragend', function(e) {
                        selectedPos = { lat: e.latLng.lat(), lng: e.latLng.lng() };
                        updateCoordinates(selectedPos);
                    });
                });

                // Map click
                map.addListener('click', function(e) {
                    if (selectedMarker) selectedMarker.setMap(null);
                    selectedPos = { lat: e.latLng.lat(), lng: e.latLng.lng() };
                    selectedMarker = new google.maps.Marker({
                        position: selectedPos,
                        map: map,
                        draggable: true,
                        animation: google.maps.Animation.DROP
                    });
                    updateCoordinates(selectedPos);
                    selectedMarker.addListener('dragend', function(e) {
                        selectedPos = { lat: e.latLng.lat(), lng: e.latLng.lng() };
                        updateCoordinates(selectedPos);
                    });
                });

                function updateCoordinates(pos) {
                    document.getElementById('coords').textContent = 'Lat: ' + pos.lat.toFixed(6) + ', Lng: ' + pos.lng.toFixed(6);
                }

                function closeModal() {
                    document.body.removeChild(modal);
                    callback(null);
                }

                closeBtn.onclick = closeModal;
                cancelBtn.onclick = closeModal;

                confirmBtn.onclick = function() {
                    if (selectedPos) {
                        var geocoder = new google.maps.Geocoder();
                        geocoder.geocode({ location: selectedPos }, function(results, status) {
                            var address = 'Lat: ' + selectedPos.lat.toFixed(6) + ', Lng: ' + selectedPos.lng.toFixed(6);
                            var city = null;
                            var country = null;
                            if (status === 'OK' && results[0]) {
                                address = results[0].formatted_address;
                                results[0].address_components.forEach(function(component) {
                                    if (component.types.indexOf('locality') >= 0) city = component.long_name;
                                    if (component.types.indexOf('country') >= 0) country = component.long_name;
                                });
                            }
                            document.body.removeChild(modal);
                            callback({
                                address: address,
                                latitude: selectedPos.lat,
                                longitude: selectedPos.lng,
                                city: city,
                                country: country
                            });
                        });
                    } else {
                        alert('Please select a location on the map');
                    }
                };

                document.addEventListener('keydown', function escHandler(e) {
                    if (e.key === 'Escape') {
                        var m = document.getElementById('map-picker-modal');
                        if (m) {
                            m.remove();
                            callback(null);
                        }
                        document.removeEventListener('keydown', escHandler);
                    }
                });
            })();
        """)
    }
}

actual fun createMapPicker(): MapPicker = MapPicker()
